import {  RecaptchaEvent } from './recaptcha-events';

export class RecaptchaSerializer {
  fromJson(json: any): RecaptchaEvent {
    const e = new RecaptchaEvent();
    if (typeof json.success !== 'undefined') {
      e.success = json.success;
      e.data = this.toJson(json.data);
      return e;
    } else {
      return this.toJson(json);
    }
  }

  toJson(e: RecaptchaEvent): any {
    if (typeof e === 'object') {
      return {
        id: e.id,
        token: e.token,
        secret_key: e.secret_key,
        edited_by: e.edited_by,
        active: e.active,
        type: e.type,
        portal_id: e.portal_id,
        main_setting_id: e.main_setting_id,
        updated_at: e.updated_at
      };
    } else {
      return e;
    }
  }
}
